export const Sources = {
	VIDEO: 'video',
	AGENCIES: 'agencies',
	COLLABORATORS: 'collaborators',
	ARCHIVE: 'archive',
	WHATSAPP: 'whatsapp',
	AI: 'ai',
	URL: 'url',
	LOCAL: 'local',
	IMPORTSTORIES: 'milenium',
};

export const MaterialType = {
	PHOTO: 'photo',
	TEXT: 'text',
	VIDEO: 'video',
};

export const CopyAction = {
	IMAGE: 'copy-image-url',
	VIDEO: 'copy-video-url',
	TEXT: 'copy-text',
	URL: 'copy-url',
};

export const CrudAction = {
	CREATE_STORY: 'create-story',
	CREATE_EVENT: 'create-event',
	CREATE_MULTIMEDIA: 'create-multimedia',
	MODERATION_SUCCESS: 'moderation-success',
	MODERATION_FAIL: 'moderation-fail',
	DUPLICATE: 'duplicate',
	EDIT: 'edit',
	DELETE: 'delete',
	STAMP: 'stamp',
	SUBMIT: 'submit',
	UNLOCK: 'unlock',
};

export const Display = {
	TABLE: 'table',
	TABLE_ESSENTIAL: 'table_essential',
	CARD: 'card',
	CARD_ESSENTIAL: 'card_essential',
};

export const PopupMode = {
	OFFCANVAS: 'offcanvas',
	POPUP: 'popup',
};

export const ImageWatermarkMode = {
	NONE: 'none',
	REPEATED: 'repeated',
	TOP_LEFT: 'top-left',
	TOP_RIGHT: 'top-right',
	CENTER: 'center',
	BOTTOM_LEFT: 'bottom-left',
	BOTTOM_RIGHT: 'bottom-right',
};